import { zodResolver } from '@hookform/resolvers/zod';
import { Box } from '@material-ui/core';
import { FormProvider, useForm } from 'react-hook-form';
import { z, ZodType } from 'zod';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import es from '@/config/languages/es';

interface PricingFormWrapperProps<T extends ZodType> {
  formSchema: (t: (textId: keyof typeof es) => string) => T;
  onSubmitForm: (data: z.infer<T>) => void;
  defaultValues?: z.infer<T>;
  loading?: boolean;
  buttons?: React.ReactElement;
  children?: React.ReactElement;
}

export const PricingFormWrapper = <T extends ZodType>({
  formSchema,
  onSubmitForm,
  defaultValues,
  children,
  buttons,
  loading,
}: PricingFormWrapperProps<T>) => {
  const { getTextIdTranslation } = useTranslation();
  type FormSchemaFields = z.infer<ReturnType<typeof formSchema>>;
  const formMethods = useForm<FormSchemaFields>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: zodResolver(formSchema(getTextIdTranslation as (textId: string | number) => string)),
    defaultValues,
  });

  if (!formMethods) return null;

  const { handleSubmit, getValues } = formMethods;

  return (
    <FormProvider {...formMethods}>
      <>
        {children}
        <Box display={'flex'} justifyContent={'end'} pt={2} alignItems={'end'}>
          {buttons}
          <StandardButton loading={loading} main onClick={handleSubmit(() => onSubmitForm(getValues()))}>
            <Text tId="CONTINUE" />
          </StandardButton>
        </Box>
      </>
    </FormProvider>
  );
};
